export default __webpack_public_path__ + "static/media/wallet-product-liquidity-mining.323914a8.svg";